// extracted by mini-css-extract-plugin
export var account = "styles-module--account--jumCL";
export var arrow = "styles-module--arrow--6V7Y-";
export var icon = "styles-module--icon--V2bGL";
export var image = "styles-module--image--73duI";
export var link = "styles-module--link--R3mBR";
export var name = "styles-module--name--ogQ-7";
export var person = "styles-module--person--5FzVK";
export var review = "styles-module--review--Hvuco";
export var reviews = "styles-module--reviews--xrC++";
export var slide = "styles-module--slide--B0wq3";
export var slider = "styles-module--slider--O+Pqg";
export var text = "styles-module--text--a0PXb";